import { actiontype } from "../actions/authactions";

const initialState = {
  isAuthenticated: false,
  user: [],
  role: [],
  profile: [],
};

export const authreducers = (state = initialState, action: any) => {
  switch (action.type) {
    case actiontype.LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    case actiontype.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: [],
      };
    case actiontype.AUTHEN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    case actiontype.GET_ROLE:
      return {
        ...state,
        role: action.payload,
      };
      case actiontype.GET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    default:
      return state;
  }
};

export default authreducers;
